import { Component, OnInit } from '@angular/core';
import { BackendInterceptor, ProductListComponent, ProductListConfigService } from 'gung-standard';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'tylo-tylo-product-list',
  templateUrl: './tylo-product-list.component.html',
  styleUrls: ['./tylo-product-list.component.css']
})
export class TyloProductListComponent extends ProductListComponent {
  constructor(
    public productListConfigService: ProductListConfigService,
    public route: ActivatedRoute,
    backendInterceptor: BackendInterceptor
  ) {
    super(productListConfigService, route, backendInterceptor);
  }
}
